import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FormCheckbox" }

import { PropType } from "vue";
import { FormValue } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormCheckbox',
  props: {
    item: {
        type: Object,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_checkbox, {
      modelValue: __props.value[__props.item.key],
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.value[__props.item.key]) = $event)),
      color: "primary",
      "hide-details": ""
    }, null, 8, ["modelValue"])
  ]))
}
}

})